import React, { useEffect, createElement } from 'react';
export function GoogleAnalytics() {
  useEffect(() => {
    // Only load on deployed site, not in preview/iframe
    if (window.self !== window.top) return;
    try {
      if (document.getElementById('ga4-script')) return;
      const script = document.createElement('script');
      script.id = 'ga4-script';
      script.async = true;
      script.src = 'https://www.googletagmanager.com/gtag/js?id=G-WYS3QHYF5R';
      script.onerror = () => {};
      document.head.appendChild(script);
      (window as any).dataLayer = (window as any).dataLayer || [];
      function gtag(...args: any[]) {
        ;
        (window as any).dataLayer.push(arguments);
      }
      ;
      (window as any).gtag = gtag;
      gtag('js', new Date());
      gtag('config', 'G-WYS3QHYF5R');
    } catch (e) {
      // Silent fail
    }
  }, []);
  return null;
}